import React from "react";
import BaseIcon from "../../utils/BaseIcon";

var UploadSystemIcon = function UploadSystemIcon(props) {
  var iconFill = "currentColor";
  return /*#__PURE__*/React.createElement(BaseIcon, props, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: iconFill,
    fillRule: "nonzero",
    d: "M23.21 15a.75.75 0 01.743.648l.007.102v1.494a3.738 3.738 0 01-3.539 3.732l-.198.005H3.79A3.738 3.738 0 01.06 17.442l-.005-.198V15.75a.75.75 0 011.493-.102l.007.102v1.494c0 1.182.916 2.15 2.078 2.231l.16.006h16.43c1.183 0 2.15-.916 2.233-2.078l.005-.16V15.75a.75.75 0 01.75-.75zM12.007 3.05a.75.75 0 01.22.033l.011.003a.74.74 0 01.3.184l-.085-.073a.753.753 0 01.012.01l.072.063 4.482 4.48.072.085a.75.75 0 01-.072.976l-.085.073a.75.75 0 01-.976-.073l-3.201-3.2V15.75l-.007.102a.75.75 0 01-1.493-.102V5.61l-3.2 3.201-.085.073a.75.75 0 01-.977-1.133l4.482-4.481.072-.064a.752.752 0 01.458-.156h-.025.02z"
  })));
};

UploadSystemIcon.displayName = "UploadSystemIcon";
UploadSystemIcon.defaultProps = {
  size: 24
};
UploadSystemIcon.displayName = "UploadSystemIcon";
UploadSystemIcon.iconName = "Upload";
export default UploadSystemIcon;